import { render, staticRenderFns } from "./InfoDetails.vue?vue&type=template&id=03b5e06a&scoped=true&"
import script from "./InfoDetails.vue?vue&type=script&lang=js&"
export * from "./InfoDetails.vue?vue&type=script&lang=js&"
import style0 from "./InfoDetails.vue?vue&type=style&index=0&id=03b5e06a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b5e06a",
  null
  
)

export default component.exports